<template class="template-page" >
    <div class="container" >
        <div class="col-12 col-sm-12 col-md-4 offset-md-4" >
            <div class="row" >
                <div class="col-12 text-center mt-5 mb-3" >
                    <a href="https://theatlass.com" > <img src="@/assets/logo.png" height="80" class="mt-5" /> </a>
                </div>
                <div class="col-12 mt-5" >
                    <b-form  @submit.prevent="login" id="login-form"  v-if="show">

                         <b-form-group id="passwordGroup" label="Password:" label-for="passwordInput">
                            <b-form-input id="passwordInput" v-bind:class="{ 'is-invalid': hasError, 'shake': shakeOn }"
                            type="password"
                            v-model="form.password"
                            required
                            placeholder="Password">
                            </b-form-input>
                        </b-form-group>

                         <b-form-group  id="rpasswordGroup" label="Enter password again:" label-for="rpasswordInput">
                            <b-form-input id="rpasswordInput" v-bind:class="{ 'is-invalid': hasError, 'shake': shakeOn }"
                            type="password"
                            v-model="form.rpassword"
                            required
                            placeholder="Enter password again">
                            </b-form-input>
                        </b-form-group>

                        <div class="row mt-4" >
                            <div class="col-12 text-center" >
                                <b-button  type="submit" variant="primary" class="btn-sm-w" > Submit </b-button>
                            </div>
                        </div>

                        <div class="form-result text-center mt-4" v-if="hasError || status || submitted || message != '' " >
                            <spinner v-if="submitted" type="small" ></spinner>
                            <span v-if="hasError "  > {{ hasError }}  </span>
							<span v-if="message != '' " > <div class="alert alert-info" > {{ message }}  </div> </span>
                        </div>

                        <div class="row mt-5 text-center " >
                            <div class="col-12 mt-3 " >
                                <router-link :to="{name: 'Login'}"  class="font-size-18" > Go to Login </router-link>
                            </div>
                        </div>

                    </b-form>

                  </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";
import { AUTH_REQUEST, AUTH_CHECK } from '@/store/actions/auth'
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
    name: "loginPage",
    components: {

    },
    data () {
        return {
            formType: 'login',

            form: {
                password: '',
                rpassword: '',

            },
            show: true,
            error: false,
            message: '',

            status: '',
            submitted: false,

			rtoken: null
        }
    },
    beforeCreate: function (){
        //location.reload();
    },
    created: function () {

        //console.log(this.$router)
        //this.isAuthenticated = this.$store.getters.isAuthenticated;
        if (this.$store.getters.isAuthenticated) {
            this.$router.push('/')
        }
        //console.log(this.$root);

		let urlParams = new URLSearchParams(window.location.search);
        if( urlParams.has('rtoken') ){
            let rtoken = urlParams.get('rtoken')
			this.rtoken = rtoken
            //console.log(rtoken)
        }else{
            this.$router.push('/login')
        }

    },
    methods: {

        login: function () {

			this.submitted = true
            if( this.form.password == this.form.rpassword && this.form.password.length >= 8 ){

                //axios request
                //PREPARE REQUEST
                let params = JSON.stringify(
                    {
                        "password":  this.form.password,
						"rtoken": this.rtoken
                    }
                )
                params = encodeURIComponent(window.btoa(params))

                //SEND REQUEST
                axios({ method: 'POST', url: process.env.ROOT_API+'/api/auth/reset-password.php', headers: { 'Content-Type': 'text/plain', }, data: params })
                //axios({ method: 'POST', url: 'https://theatlass.com/api/auth/reset-password.php', headers: { 'Content-Type': 'text/plain', }, data: params })
                .then(resp => {

					let r = resp.data;
					this.message = r.data
					this.submitted = false


                }).catch(error => {
                    console.log(error)
                }); //end axios
                //axios request

			}else{

				if( this.form.password != this.form.rpassword ){
					this.message = "Passwords need to match"
				}
				if( this.form.password.length < 8 ){
					this.message = "Password needs to be at least 8 characters long"
				}

				this.submitted = false

			}

        },

        switchFormType( type ){

            this.formType = type
            this.message = ''
            this.$store.state.hasError = false
            this.submitted = false

        }
    },
    computed: {
        hasError() {
            if( this.$store.getters.authStatus == 'error' ){
                this.submitted = false
                return this.$store.getters.geterror
            }else{
                return false
            }
        },
        shakeOn() {

            if( this.$store.getters.authStatus == 'error' ){
                return true
            }else{
                return false
            }
            setTimeout(function () { return false }, 800)

        },

    },

}
</script>

<style lang="scss" scoped>

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }

    .shake {
      animation: shake 1s;
    }

</style>



// WEBPACK FOOTER //
// src/templates/auth/resetPassword.vue